// @noflow
// FIXME somehow this file's types are very broken
import React, { PureComponent } from "react"
import keymirror from "keymirror"
import classNames from "classnames"
import type { Node } from "react"

import RadioButtonsRadio from "../RadioButtons/RadioButtonsRadio"
import type { SwitchButtonsOption } from "./SwitchButtons.types"

export const SWITCH_BUTTONS_TYPES = keymirror({
  DEFAULT: null,
  DETACHED: null,
  SMALL: null,
})

const ENTER = 13
const SPACE = 32

type Props = {
  active: string,
  allowClickActive?: boolean,
  forceMobileView?: boolean,
  fullwidth: boolean,
  multipleLines: boolean,
  onChange?: string => void, // not required, options can be components with own handlers
  options: Array<SwitchButtonsOption> | Node,
  optionsAdditionalInfo: Node, // Optional info under options buttons
  renderOptionsRaw: boolean, // Renders directly options DOMs
  selected: string,
  theme: string,
  type: $Values<typeof SWITCH_BUTTONS_TYPES>,
  keyAsClass: string,
}

export default class SwitchButtons extends PureComponent<Props> {
  static defaultProps = {
    theme: "default", // TODO: Enums
    type: SWITCH_BUTTONS_TYPES.DEFAULT,
  }

  handleChange = (option: SwitchButtonsOption) => {
    const { onChange, active, allowClickActive } = this.props

    if (
      typeof onChange === "function" &&
      !option.disabled &&
      (option.key !== active || allowClickActive)
    ) {
      onChange(option.key)
    }
  }

  renderSimpleOptions = () => {
    const { active, options, selected, type, keyAsClass } = this.props

    if (!Array.isArray(options)) {
      return null
    }

    return (
      <div className="SwitchButtons-options" data-test="SwitchButtons-options">
        {options.map(option => (
          <div
            data-test={`SwitchButtons-option ${option.key}`}
            // eslint-disable-next-line react/no-array-index-key
            key={option.key}
            className={classNames("SwitchButtons-option", {
              _active: option.key === active,
              _selected: option.key === selected,
              _disabled: option.disabled,
              [option.key]: keyAsClass,
            })}
            onClick={() => {
              this.handleChange(option)
            }}
            onKeyDown={e => {
              if (e.keyCode === ENTER) {
                this.handleChange(option)
              } else if (e.keyCode === SPACE) {
                e.preventDefault()
                this.handleChange(option)
              }
            }}
            role="button"
            tabIndex={!option.disabled && "0"}
          >
            {type === SWITCH_BUTTONS_TYPES.DETACHED && (
              <RadioButtonsRadio checked={option.key === selected} />
            )}

            {option.icon && <i className={`SwitchButtons-option-icon ${option.icon}`} />}

            <span className="SwitchButtons-option-label">{option.name}</span>

            {option.note && <span className="SwitchButtons-option-note">{option.note}</span>}
          </div>
        ))}
      </div>
    )
  }

  renderSimpleOptionsAdditionalInfo() {
    const { options } = this.props
    if (!Array.isArray(options)) {
      return null
    }
    return (
      <div className="SwitchButtons-additionalInfo">
        {options.map(option => (
          <div className="SwitchButtons-additionalInfo-item" key={option.key}>
            <ul className="spCheckList">
              {option.additionalInfo.map((info, i) => (
                <li
                  // eslint-disable-next-line react/no-array-index-key
                  key={i}
                  className="spTypo-caption"
                >
                  {info}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    )
  }

  renderRawOptionsAdditionalInfo = () => (
    <div className="SwitchButtons-additionalInfo">{this.props.optionsAdditionalInfo}</div>
  )

  renderRawOptions = () => (
    // $FlowFixMe we believe options are React nodes, don't know how to persuade flow
    <div className="SwitchButtons-options">{this.props.options}</div>
  )

  render() {
    const {
      fullwidth,
      forceMobileView,
      multipleLines,
      options,
      optionsAdditionalInfo,
      renderOptionsRaw,
      theme,
      type,
    } = this.props

    // TODO: Assert (this.props.active !== this.props.selected)
    const hasOptionsAdditionalInfo =
      optionsAdditionalInfo ||
      (Array.isArray(options) && options.some(option => option.additionalInfo))

    return (
      <div
        className={classNames(
          "SwitchButtons",
          {
            _fullwidth: fullwidth,
            _multipleLines: multipleLines,
            _defaultMobileView: !forceMobileView,
          },
          `_${theme}`,
          `_${type.toLowerCase()}`,
        )}
      >
        {renderOptionsRaw ? this.renderRawOptions() : this.renderSimpleOptions()}

        {hasOptionsAdditionalInfo && optionsAdditionalInfo && this.renderRawOptionsAdditionalInfo()}

        {hasOptionsAdditionalInfo &&
          !optionsAdditionalInfo &&
          this.renderSimpleOptionsAdditionalInfo()}
      </div>
    )
  }
}
